module.exports = __webpack_public_path__ + "img/man-silueta.8ddb5aa3.png";